/**
 * A function to create a log object for the 'landAfterShare' event (evid: 602)
 *
 * Event description: an indication of landing in the fullscreen page, following a share
 *
 * @param {landAfterShareParams} params - The parameters for this event
 * @property {string} hashtag - name/auto/null
 * @property {GUID} instance_id
 * @property {GUID} biToken
 * @property {number} reach_level - starting at 1
 * @property {GUID} visitor_id
 * @return {LogObject<landAfterShareParams>} LogObject<landAfterShareParams>
 */
export function landAfterShare(params) {
    return { evid: 602, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'navigationInCollectionMemberArea' event (evid: 234)
 *
 * Event description: when user navigation In collection member area
 *
 * @param {navigationInCollectionMemberAreaParams} params - The parameters for this event
 * @property {string} albumID - album_id
 * @property {string} category - sellected_media/discussions/members/about
 * @property {string} collection_id - unique id for collection
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken
 * @property {string} role - the role in the album (owner/member)
 * @property {string} visitorId - id of the member in the collection
 * @property {GUID} visitor_id
 * @return {LogObject<navigationInCollectionMemberAreaParams>} LogObject<navigationInCollectionMemberAreaParams>
 */
export function navigationInCollectionMemberArea(params) {
    return { evid: 234, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'albumNameTooltip' event (evid: 295)
 *
 * Event description: when an tooltip is presented with more info regarding album name
 *
 * @param {albumNameTooltipParams} params - The parameters for this event
 * @property {string} albumID - album_id
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - []
 * @property {string} origin - Builder/Wizard
 * @property {string} tooltipName - album name/url characters
 * @property {GUID} visitor_id
 * @return {LogObject<albumNameTooltipParams>} LogObject<albumNameTooltipParams>
 */
export function albumNameTooltip(params) {
    return { evid: 295, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'createCollection' event (evid: 198)
 *
 * Event description: when user click to create collection
 *
 * @param {createCollectionParams} params - The parameters for this event
 * @property {string} albumID - album_id
 * @property {string} collection_id - unique id for collection
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken
 * @property {string} origin - collection settings/ new collection / LiveSite
 * @property {string} params - collection params
 * @property {string} role - the role in the album (owner/member)
 * @property {string} visitorId - id of the member in the collection
 * @property {GUID} visitor_id
 * @return {LogObject<createCollectionParams>} LogObject<createCollectionParams>
 */
export function createCollection(params) {
    return { evid: 198, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'expand' event (evid: 504)
 *
 * Event description: zoom mode
 *
 * @param {expandParams} params - The parameters for this event
 * @property {GUID} gallery_id
 * @property {string} galleryType - store/pro/photo/album
 * @property {GUID} instance_id
 * @property {GUID} biToken
 * @property {string} selection
 * @property {GUID} visitor_id
 * @return {LogObject<expandParams>} LogObject<expandParams>
 */
export function expand(params) {
    return { evid: 504, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'clickSaveCollection' event (evid: 232)
 *
 * Event description: when save collection media
 *
 * @param {clickSaveCollectionParams} params - The parameters for this event
 * @property {string} albumID - album_id
 * @property {number} amountOfItems - the number of items in the collection include the new items
 * @property {number} amountOfItemsSelected - the number of items that add to the collection
 * @property {string} collection_id - unique id for collection
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken
 * @property {string} origin - .
 * @property {string} role - the role in the album (owner/member=client)
 * @property {string} visitorId - id of the member in the collection
 * @property {GUID} visitor_id
 * @return {LogObject<clickSaveCollectionParams>} LogObject<clickSaveCollectionParams>
 */
export function clickSaveCollection(params) {
    return { evid: 232, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'downloadFilesFromCollection' event (evid: 218)
 *
 * Event description: when user choose the download way
 *
 * @param {downloadFilesFromCollectionParams} params - The parameters for this event
 * @property {string} albumID - album_id
 * @property {string} button_name - action name
 * @property {string} collection_id - unique id for collection
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken
 * @property {string} origin - .
 * @property {string} role - role in the album (owner/member)
 * @property {string} source - bzm/etc.....
 * @property {string} visitorId - id of the member in the collection
 * @property {GUID} visitor_id
 * @return {LogObject<downloadFilesFromCollectionParams>} LogObject<downloadFilesFromCollectionParams>
 */
export function downloadFilesFromCollection(params) {
    return { evid: 218, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'providerCartCheckout' event (evid: 803)
 *
 * Event description: click on checkout
 *
 * @param {providerCartCheckoutParams} params - The parameters for this event
 * @property {string} app_id - []
 * @property {number} count
 * @property {string} currency
 * @property {GUID} gallery_id - []
 * @property {GUID} instance_id
 * @property {GUID} biToken
 * @property {string} name - Deprecated
 * @property {number} price
 * @property {GUID} storeId
 * @property {GUID} visitor_id
 * @return {LogObject<providerCartCheckoutParams>} LogObject<providerCartCheckoutParams>
 */
export function providerCartCheckout(params) {
    return { evid: 803, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'info' event (evid: 503)
 *
 * Event description: info clicked
 *
 * @param {infoParams} params - The parameters for this event
 * @property {GUID} gallery_id - {}
 * @property {string} galleryType - store or pro
 * @property {GUID} instance_id
 * @property {GUID} biToken
 * @property {string} origin - gallery or expand mode
 * @property {GUID} visitor_id
 * @return {LogObject<infoParams>} LogObject<infoParams>
 */
export function info(params) {
    return { evid: 503, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'galleryItemExpanded' event (evid: 521)
 *
 * Event description: Gallery item is expanded successfully (only OOI, beside art store)
 *
 * @param {galleryItemExpandedParams} params - The parameters for this event
 * @property {GUID} galleryId - []
 * @property {string} galleryType - store, if null then gallery (works till art store is on Iframe)
 * @property {GUID} instance_id
 * @property {string} mediaType - text,video,image
 * @property {GUID} biToken
 * @property {GUID} visitor_id
 * @return {LogObject<galleryItemExpandedParams>} LogObject<galleryItemExpandedParams>
 */
export function galleryItemExpanded(params) {
    return { evid: 521, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'previewItemInCollection' event (evid: 230)
 *
 * Event description: Arrived when collection member click preview item
 *
 * @param {previewItemInCollectionParams} params - The parameters for this event
 * @property {string} albumID - album_id
 * @property {string} collection_id - unique id for collection
 * @property {GUID} instance_id - instance_id
 * @property {string} itemId - id of the chosen item
 * @property {GUID} biToken
 * @property {string} role - the role in the album (owner/member)
 * @property {string} source - preview/selected_media/discussions
 * @property {string} visitorId - id of the member in the collection
 * @property {GUID} visitor_id
 * @return {LogObject<previewItemInCollectionParams>} LogObject<previewItemInCollectionParams>
 */
export function previewItemInCollection(params) {
    return { evid: 230, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'share' event (evid: 500)
 *
 * Event description: share clicked
 *
 * @param {shareParams} params - The parameters for this event
 * @property {GUID} gallery_id
 * @property {string} galleryType - store/pro/photo/album
 * @property {GUID} instance_id
 * @property {GUID} biToken
 * @property {string} origin
 * @property {string} platform
 * @property {GUID} visitor_id
 * @return {LogObject<shareParams>} LogObject<shareParams>
 */
export function share(params) {
    return { evid: 500, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'downloadImage' event (evid: 805)
 *
 * Event description: download image
 *
 * @param {downloadImageParams} params - The parameters for this event
 * @property {string} app_id - []
 * @property {GUID} gallery_id - []
 * @property {GUID} instance_id
 * @property {GUID} biToken
 * @property {GUID} visitor_id
 * @return {LogObject<downloadImageParams>} LogObject<downloadImageParams>
 */
export function downloadImage(params) {
    return { evid: 805, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'galleryClickOnItem' event (evid: 520)
 *
 * Event description: UOU clicks on an item in a gallery (only OOI, beside art store)
 *
 * @param {galleryClickOnItemParams} params - The parameters for this event
 * @property {string} action - expand, link, nothing, thumbnail
 * @property {GUID} galleryId - []
 * @property {string} galleryType - store, if null then gallery (works till art store is on Iframe)
 * @property {GUID} instance_id
 * @property {string} layout - []
 * @property {string} mediaType - image, video, text
 * @property {GUID} biToken
 * @property {GUID} visitor_id
 * @return {LogObject<galleryClickOnItemParams>} LogObject<galleryClickOnItemParams>
 */
export function galleryClickOnItem(params) {
    return { evid: 520, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'gogLoaded' event (evid: 301)
 *
 * Event description: gog_loaded
 *
 * @param {gogLoadedParams} params - The parameters for this event
 * @property {GUID} instance_id
 * @property {boolean} is_editor - -
 * @property {boolean} is_owner - -
 * @property {GUID} biToken
 * @property {GUID} visitor_id
 * @return {LogObject<gogLoadedParams>} LogObject<gogLoadedParams>
 */
export function gogLoaded(params) {
    return { evid: 301, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'buyBuyNowClick' event (evid: 800)
 *
 * Event description: click buy now button in gallery
 *
 * @param {buyBuyNowClickParams} params - The parameters for this event
 * @property {GUID} gallery_id - []
 * @property {GUID} instance_id
 * @property {GUID} biToken
 * @property {GUID} storeId
 * @property {GUID} visitor_id
 * @return {LogObject<buyBuyNowClickParams>} LogObject<buyBuyNowClickParams>
 */
export function buyBuyNowClick(params) {
    return { evid: 800, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'addCommentOnAnItemCollection' event (evid: 229)
 *
 * Event description: Arrived when collection member add comment on an item
 *
 * @param {addCommentOnAnItemCollectionParams} params - The parameters for this event
 * @property {string} albumID - album_id
 * @property {string} collection_id - unique id for collection
 * @property {GUID} instance_id - instance_id
 * @property {string} itemId - id of the chosen item
 * @property {GUID} biToken
 * @property {string} role - the role in the album (owner/member)
 * @property {string} source - preview/selected_media/discussions
 * @property {string} visitorId - id of the member in the collection
 * @property {GUID} visitor_id
 * @return {LogObject<addCommentOnAnItemCollectionParams>} LogObject<addCommentOnAnItemCollectionParams>
 */
export function addCommentOnAnItemCollection(params) {
    return { evid: 229, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'proGalleryErrorUou' event (evid: 512)
 *
 * Event description: triggered when the client finds a server error
 *
 * @param {proGalleryErrorUouParams} params - The parameters for this event
 * @property {string} compId
 * @property {string} errorType - the name of the error
 * @property {string} error_type - []
 * @property {GUID} gallery_id - []
 * @property {string} galleryType - []
 * @property {GUID} instance_id - []
 * @property {GUID} biToken - []
 * @property {GUID} visitor_id
 * @return {LogObject<proGalleryErrorUouParams>} LogObject<proGalleryErrorUouParams>
 */
export function proGalleryErrorUou(params) {
    return { evid: 512, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'paymentExcepted' event (evid: 506)
 *
 * Event description: payment_excepted
 *
 * @param {paymentExceptedParams} params - The parameters for this event
 * @property {GUID} couponId - {}
 * @property {string} currency - {}
 * @property {GUID} gallery_id - {}
 * @property {GUID} instance_id
 * @property {GUID} biToken
 * @property {number} price - {}
 * @property {GUID} visitor_id
 * @return {LogObject<paymentExceptedParams>} LogObject<paymentExceptedParams>
 */
export function paymentExcepted(params) {
    return { evid: 506, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'providerBuyAddToCart' event (evid: 802)
 *
 * Event description: click on add to cart
 *
 * @param {providerBuyAddToCartParams} params - The parameters for this event
 * @property {string} app_id - []
 * @property {string} currency
 * @property {GUID} gallery_id - []
 * @property {GUID} instance_id
 * @property {GUID} biToken
 * @property {string} name
 * @property {number} price
 * @property {GUID} storeId
 * @property {GUID} visitor_id
 * @return {LogObject<providerBuyAddToCartParams>} LogObject<providerBuyAddToCartParams>
 */
export function providerBuyAddToCart(params) {
    return { evid: 802, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'albumNameError' event (evid: 294)
 *
 * Event description: when an error is presented indicating that an album name must be filled
 *
 * @param {albumNameErrorParams} params - The parameters for this event
 * @property {string} albumID - album_id
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - []
 * @property {string} origin - Builder/Wizard
 * @property {GUID} visitor_id
 * @return {LogObject<albumNameErrorParams>} LogObject<albumNameErrorParams>
 */
export function albumNameError(params) {
    return { evid: 294, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'collectionCreated' event (evid: 199)
 *
 * Event description: arrived when the collection created
 *
 * @param {collectionCreatedParams} params - The parameters for this event
 * @property {string} albumID - album_id
 * @property {string} collection_id - unique id for collection
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken
 * @property {string} origin - collection settings/ new collection / LiveSite
 * @property {string} params - collection params
 * @property {string} role - the role in the album (owner/member)
 * @property {string} visitorId - id of the member in the collection
 * @property {GUID} visitor_id
 * @return {LogObject<collectionCreatedParams>} LogObject<collectionCreatedParams>
 */
export function collectionCreated(params) {
    return { evid: 199, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'albumActions' event (evid: 300)
 *
 * Event description: album_actions
 *
 * @param {albumActionsParams} params - The parameters for this event
 * @property {string} action - -
 * @property {string} album_id - -
 * @property {GUID} app_site_id - -
 * @property {GUID} instance_id
 * @property {GUID} biToken
 * @property {GUID} visitor_id
 * @return {LogObject<albumActionsParams>} LogObject<albumActionsParams>
 */
export function albumActions(params) {
    return { evid: 300, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'proGalleryLoadUou' event (evid: 304)
 *
 * Event description: pro gallery end point uou client
 *
 * @param {proGalleryLoadUouParams} params - The parameters for this event
 * @property {string} endpoint
 * @property {GUID} gallery_id
 * @property {string} galleryType - store/pro/photo/album
 * @property {GUID} instance_id
 * @property {number} items_count
 * @property {number} loading_time
 * @property {GUID} biToken
 * @property {string} phase
 * @property {GUID} visitor_id
 * @return {LogObject<proGalleryLoadUouParams>} LogObject<proGalleryLoadUouParams>
 */
export function proGalleryLoadUou(params) {
    return { evid: 304, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'shareGroup' event (evid: 601)
 *
 * Event description: when a uou shares a group of photos
 *
 * @param {shareGroupParams} params - The parameters for this event
 * @property {string} hashtag - []
 * @property {GUID} instance_id
 * @property {GUID} biToken
 * @property {number} group_size - num of shared photos
 * @property {string} platform - share platform (network)
 * @property {GUID} visitor_id
 * @return {LogObject<shareGroupParams>} LogObject<shareGroupParams>
 */
export function shareGroup(params) {
    return { evid: 601, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'thankYouPageLoaded' event (evid: 804)
 *
 * Event description: thank you page loaded
 *
 * @param {thankYouPageLoadedParams} params - The parameters for this event
 * @property {GUID} gallery_id - []
 * @property {GUID} instance_id
 * @property {GUID} biToken
 * @property {GUID} visitor_id
 * @return {LogObject<thankYouPageLoadedParams>} LogObject<thankYouPageLoadedParams>
 */
export function thankYouPageLoaded(params) {
    return { evid: 804, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'photoAlbumButtonOnClick' event (evid: 211)
 *
 * Event description: A click event in Photo album 2.0
 *
 * @param {photoAlbumButtonOnClickParams} params - The parameters for this event
 * @property {string} albumID - []
 * @property {string} buttonName - []
 * @property {string} buttonOrigin - []
 * @property {GUID} instance_id
 * @property {string} lightroomVersion - version
 * @property {GUID} biToken
 * @property {string} origin - Editor, BM, custom origin
 * @property {string} screenName - []
 * @property {GUID} visitor_id
 * @return {LogObject<photoAlbumButtonOnClickParams>} LogObject<photoAlbumButtonOnClickParams>
 */
export function photoAlbumButtonOnClick(params) {
    return { evid: 211, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'buySelectLicense' event (evid: 801)
 *
 * Event description: select license
 *
 * @param {buySelectLicenseParams} params - The parameters for this event
 * @property {string} app_id - []
 * @property {GUID} gallery_id - []
 * @property {GUID} instance_id
 * @property {GUID} biToken
 * @property {string} name
 * @property {GUID} storeId
 * @property {GUID} visitor_id
 * @return {LogObject<buySelectLicenseParams>} LogObject<buySelectLicenseParams>
 */
export function buySelectLicense(params) {
    return { evid: 801, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'photoAlbumCoverLoaded' event (evid: 303)
 *
 * Event description: photo album cover is loaded (with option to click view photos and see full gallery)
 *
 * @param {photoAlbumCoverLoadedParams} params - The parameters for this event
 * @property {string} albumID
 * @property {string} endpoint - []
 * @property {GUID} instance_id
 * @property {number} loading_time - []
 * @property {GUID} biToken
 * @property {GUID} visitor_id
 * @return {LogObject<photoAlbumCoverLoadedParams>} LogObject<photoAlbumCoverLoadedParams>
 */
export function photoAlbumCoverLoaded(params) {
    return { evid: 303, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'download' event (evid: 502)
 *
 * Event description: download success
 *
 * @param {downloadParams} params - The parameters for this event
 * @property {GUID} gallery_id
 * @property {string} galleryType - store/pro/photo/album
 * @property {GUID} instance_id
 * @property {GUID} biToken
 * @property {string} origin
 * @property {GUID} visitor_id
 * @return {LogObject<downloadParams>} LogObject<downloadParams>
 */
export function download(params) {
    return { evid: 502, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'migratedLoveData' event (evid: 305)
 *
 * Event description: love count migrated to new service
 *
 * @param {migratedLoveDataParams} params - The parameters for this event
 * @property {GUID} gallery_id - []
 * @property {GUID} instance_id
 * @property {string} migration_status - start/success
 * @property {GUID} biToken
 * @property {GUID} visitor_id
 * @return {LogObject<migratedLoveDataParams>} LogObject<migratedLoveDataParams>
 */
export function migratedLoveData(params) {
    return { evid: 305, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'shareNew' event (evid: 511)
 *
 * Event description: share clicked
 *
 * @param {shareNewParams} params - The parameters for this event
 * @property {GUID} gallery_id - {}
 * @property {GUID} instance_id
 * @property {GUID} biToken
 * @property {string} origin - {fullscreen, gallery}
 * @property {string} platform - {}
 * @property {GUID} visitor_id
 * @return {LogObject<shareNewParams>} LogObject<shareNewParams>
 */
export function shareNew(params) {
    return { evid: 511, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'dropDownMenuOnPhoto' event (evid: 285)
 *
 * Event description: Drop down menu on photo
 *
 * @param {dropDownMenuOnPhotoParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {number} loading_time - []
 * @property {GUID} biToken - []
 * @property {GUID} visitor_id - []
 * @return {LogObject<dropDownMenuOnPhotoParams>} LogObject<dropDownMenuOnPhotoParams>
 */
export function dropDownMenuOnPhoto(params) {
    return { evid: 285, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'popupOpened' event (evid: 279)
 *
 * Event description: when a popup is presented to a user
 *
 * @param {popupOpenedParams} params - The parameters for this event
 * @property {string} albumID - album_id
 * @property {string} collection_id - list id
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - []
 * @property {string} origin - origin that opened popup
 * @property {string} popupName - popup title/description
 * @property {string} role - member/owner
 * @property {GUID} visitor_id
 * @return {LogObject<popupOpenedParams>} LogObject<popupOpenedParams>
 */
export function popupOpened(params) {
    return { evid: 279, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'buyGalleryAddToCart' event (evid: 806)
 *
 * Event description: click on add to cart from gallery side
 *
 * @param {buyGalleryAddToCartParams} params - The parameters for this event
 * @property {GUID} gallery_id - []
 * @property {GUID} instance_id
 * @property {GUID} biToken
 * @property {string} providerId - []
 * @property {GUID} visitor_id
 * @return {LogObject<buyGalleryAddToCartParams>} LogObject<buyGalleryAddToCartParams>
 */
export function buyGalleryAddToCart(params) {
    return { evid: 806, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'paymentError' event (evid: 507)
 *
 * Event description: payment_error
 *
 * @param {paymentErrorParams} params - The parameters for this event
 * @property {GUID} couponId - {}
 * @property {string} currency - {}
 * @property {GUID} gallery_id - {}
 * @property {GUID} instance_id
 * @property {GUID} biToken
 * @property {number} price - {}
 * @property {GUID} visitor_id
 * @return {LogObject<paymentErrorParams>} LogObject<paymentErrorParams>
 */
export function paymentError(params) {
    return { evid: 507, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'clickOnInviteMemberToCollection' event (evid: 233)
 *
 * Event description: click on invite member to collection
 *
 * @param {clickOnInviteMemberToCollectionParams} params - The parameters for this event
 * @property {string} albumID - album_id
 * @property {string} collection_id - unique id for collection
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken
 * @property {string} role - the role in the album (owner/member)
 * @property {string} source - bzm/member area
 * @property {string} visitorId - id of the member in the collection
 * @property {GUID} visitor_id
 * @return {LogObject<clickOnInviteMemberToCollectionParams>} LogObject<clickOnInviteMemberToCollectionParams>
 */
export function clickOnInviteMemberToCollection(params) {
    return { evid: 233, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'artStorePerformanceUou' event (evid: 306)
 *
 * Event description: performance testing event - uou
 *
 * @param {artStorePerformanceUouParams} params - The parameters for this event
 * @property {number} client_rt - client rendering time
 * @property {string} end_point - shop, checkout, configuration, manage, purchaseEnd, cart
 * @property {GUID} instance_id - []
 * @property {boolean} is_optimization_on - true/false
 * @property {GUID} biToken - []
 * @property {number} server_rt - server rendering time
 * @property {GUID} visitor_id
 * @return {LogObject<artStorePerformanceUouParams>} LogObject<artStorePerformanceUouParams>
 */
export function artStorePerformanceUou(params) {
    return { evid: 306, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'gogAlbumClick' event (evid: 302)
 *
 * Event description: gog_album_click
 *
 * @param {gogAlbumClickParams} params - The parameters for this event
 * @property {string} album_id - -
 * @property {GUID} app_site_id - -
 * @property {GUID} instance_id
 * @property {boolean} is_owner - -
 * @property {GUID} biToken
 * @property {GUID} visitor_id
 * @return {LogObject<gogAlbumClickParams>} LogObject<gogAlbumClickParams>
 */
export function gogAlbumClick(params) {
    return { evid: 302, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'galleryRendered' event (evid: 508)
 *
 * Event description: Pro Gallery or Art Store are successfully rendered in Viewer.
 *
 * @param {galleryRenderedParams} params - The parameters for this event
 * @property {number} numberOfItems - number of images in gallery
 * @property {number} customLayoutID - id number
 * @property {GUID} gallery_id - []
 * @property {string} galleryType - pro gallery or art store
 * @property {GUID} instance_id
 * @property {boolean} isLean - true if gallery is lean eligible
 * @property {string} itemSource - gallery, Corvid, Albums
 * @property {string} layoutType - presets, custom
 * @property {GUID} biToken
 * @property {string} notLeanReason - if is_lean is false, why. list split by ','
 * @property {string} styleParams - json
 * @property {number} presetLayoutID - id number
 * @property {GUID} visitor_id
 * @return {LogObject<galleryRenderedParams>} LogObject<galleryRenderedParams>
 */
export function galleryRendered(params) {
    return { evid: 508, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'clickButtonInPopup' event (evid: 297)
 *
 * Event description: when a user clicks a button in the popup
 *
 * @param {clickButtonInPopupParams} params - The parameters for this event
 * @property {string} albumID - album_id
 * @property {string} buttonName - button clicked
 * @property {string} collection_id - list id
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - []
 * @property {string} popupName - popup title/description
 * @property {string} role - member/owner
 * @property {GUID} visitor_id - -
 * @return {LogObject<clickButtonInPopupParams>} LogObject<clickButtonInPopupParams>
 */
export function clickButtonInPopup(params) {
    return { evid: 297, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'openWizardCreateCollection' event (evid: 208)
 *
 * Event description: when user open create collection wizard ( create collection from bo/members area)
 *
 * @param {openWizardCreateCollectionParams} params - The parameters for this event
 * @property {string} albumID - album_id
 * @property {string} button_name - bzm top button/ bzm + sign / members area
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken
 * @property {string} role - the role in the album (owner/member)
 * @property {string} source - bzm/member area
 * @property {string} visitorId - id of the member in the collection
 * @property {GUID} visitor_id
 * @return {LogObject<openWizardCreateCollectionParams>} LogObject<openWizardCreateCollectionParams>
 */
export function openWizardCreateCollection(params) {
    return { evid: 208, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'proGalleryLoaded' event (evid: 510)
 *
 * Event description: when a UOU loads a gallery
 *
 * @param {proGalleryLoadedParams} params - The parameters for this event
 * @property {number} avg_image_loading_time - first_50_images
 * @property {number} first_screen_load_time - load_time
 * @property {GUID} gallery_id - {}
 * @property {GUID} instance_id
 * @property {GUID} biToken
 * @property {GUID} visitor_id
 * @return {LogObject<proGalleryLoadedParams>} LogObject<proGalleryLoadedParams>
 */
export function proGalleryLoaded(params) {
    return { evid: 510, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'xxxcheckout' event (evid: 505)
 *
 * Event description: buy now clicked
 *
 * @param {xxxcheckoutParams} params - The parameters for this event
 * @property {GUID} gallery_id - {}
 * @property {GUID} instance_id
 * @property {GUID} biToken
 * @property {GUID} visitor_id
 * @return {LogObject<xxxcheckoutParams>} LogObject<xxxcheckoutParams>
 */
export function xxxcheckout(params) {
    return { evid: 505, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'proGalleryClickOnCustomButton' event (evid: 807)
 *
 * Event description: UoU clicks on custom button in pro gallery (parallel to event 800 in art store)
 *
 * @param {proGalleryClickOnCustomButtonParams} params - The parameters for this event
 * @property {string} action - type of action expected by the buton
 * @property {string} button_text - []
 * @property {GUID} gallery_id - []
 * @property {GUID} instance_id - []
 * @property {GUID} biToken - []
 * @property {GUID} visitor_id
 * @return {LogObject<proGalleryClickOnCustomButtonParams>} LogObject<proGalleryClickOnCustomButtonParams>
 */
export function proGalleryClickOnCustomButton(params) {
    return { evid: 807, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'love' event (evid: 501)
 *
 * Event description: Love clicked
 *
 * @param {loveParams} params - The parameters for this event
 * @property {string} albumID - album id
 * @property {GUID} gallery_id
 * @property {string} galleryType - store/pro/photo/album
 * @property {GUID} instance_id
 * @property {GUID} biToken
 * @property {string} origin
 * @property {string} role - member/owner
 * @property {GUID} visitor_id
 * @return {LogObject<loveParams>} LogObject<loveParams>
 */
export function love(params) {
    return { evid: 501, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'clickOnSelectMediaCollection' event (evid: 228)
 *
 * Event description: Arrived when visitor click on start select media in collection
 *
 * @param {clickOnSelectMediaCollectionParams} params - The parameters for this event
 * @property {string} albumID - album_id
 * @property {string} collection_id - unique id for collection
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken
 * @property {string} role - the role in the album (owner/member)
 * @property {string} visitorId - id of the member in the collection
 * @property {GUID} visitor_id
 * @return {LogObject<clickOnSelectMediaCollectionParams>} LogObject<clickOnSelectMediaCollectionParams>
 */
export function clickOnSelectMediaCollection(params) {
    return { evid: 228, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'selectPhoto' event (evid: 600)
 *
 * Event description: when a uou chooses a photo
 *
 * @param {selectPhotoParams} params - The parameters for this event
 * @property {number} group_size - number of item in session
 * @property {GUID} instance_id
 * @property {GUID} biToken
 * @property {number} num_of_item_in_group - []
 * @property {string} value - choose/unchoose
 * @property {GUID} visitor_id
 * @return {LogObject<selectPhotoParams>} LogObject<selectPhotoParams>
 */
export function selectPhoto(params) {
    return { evid: 600, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'proGalleryLoadError' event (evid: 509)
 *
 * Event description: when there is a pro gallery load error
 *
 * @param {proGalleryLoadErrorParams} params - The parameters for this event
 * @property {GUID} gallery_id - {}
 * @property {GUID} instance_id
 * @property {GUID} biToken
 * @property {GUID} visitor_id
 * @return {LogObject<proGalleryLoadErrorParams>} LogObject<proGalleryLoadErrorParams>
 */
export function proGalleryLoadError(params) {
    return { evid: 509, src: 65, endpoint: 'photo-ugc', params };
}
/**
 * A function to create a log object for the 'photoAlbumGalleryLoaded' event (evid: 307)
 *
 * Event description: photo album gallery is loaded after clicking view photos in the cover image
 *
 * @param {photoAlbumGalleryLoadedParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @property {number} loading_time - []
 * @property {GUID} biToken - []
 * @property {GUID} visitor_id - []
 * @return {LogObject<photoAlbumGalleryLoadedParams>} LogObject<photoAlbumGalleryLoadedParams>
 */
export function photoAlbumGalleryLoaded(params) {
    return { evid: 307, src: 65, endpoint: 'photo-ugc', params };
}
//# sourceMappingURL=index.js.map